import '@assets/styles/tiptap-preview.css';

import { handleApiResponse } from '@src/api/apiClient/axiosClient.ts';
import { articleApiClient } from '@src/api/tenant/article/articleApiClient';
import { Article } from '@src/api/types/article.ts';
import { MediaCategory } from '@src/api/types/mediaCategory';
import { MediaTag } from '@src/api/types/mediaTag';
import ArticlePreviewContent from '@src/features/shared/ArticlePreviewContent';
import { TENANT_URL } from '@src/routes/tenant';
import { useEffect, useState } from 'react';
import { generatePath, useParams } from 'react-router-dom';

export type DummyArticle = {
  id: number;
  title: string;
  content: string;
  published_at: string;
  category: MediaCategory;
  tags: MediaTag[];
  thumbnail_url?: string;
};

function ArticlePreview() {
  const { uuid } = useParams<{ uuid: string }>();
  const [article, setArticle] = useState<Article | undefined>(undefined);
  const maxDisplayNumberOfRelatedArticles = 3;

  const dummyRelatedArticle: DummyArticle = {
    id: 1,
    title: 'タイトル',
    content: '本文',
    published_at: '2025-01-01',
    category: {
      id: 1,
      name: 'カテゴリ',
      slug: 'category',
      viewable: true,
      order: 1,
    },
    tags: [{ id: 1, name: 'タグ' }],
  };

  const dummyRelatedArticles: DummyArticle[] = Array.from(
    { length: maxDisplayNumberOfRelatedArticles },
    (_, index) => ({
      ...dummyRelatedArticle,
      id: index + 1,
    }),
  );

  const shareData = article
    ? {
        url: `${window.location.origin}${generatePath(TENANT_URL.ARTICLES_PREVIEW, { uuid: uuid })}`,
        title: article.title,
        tags: article.tags ? article.tags.map((tag) => tag.name) : [],
      }
    : null;

  useEffect(() => {
    const fetchData = async () => {
      if (!uuid) {
        return;
      }

      const res = await articleApiClient.findByArticlePreviewUuid(uuid);
      handleApiResponse(res, async (data) => {
        setArticle(data);
      });
    };

    fetchData();
  }, [uuid]);

  return (
    <main>
      {article && (
        <ArticlePreviewContent
          article={article}
          relatedArticles={dummyRelatedArticles}
          shareData={shareData}
        />
      )}
    </main>
  );
}

export default ArticlePreview;
